import React from "react";
import { RaiseColors } from "client/componentLibrary";
import styles from "./SearchField.module.scss";
import { IconConstants } from "componentLibrary";
import classnames from "classnames";
// please refer to the following link for the button you are looking for
// https://www.figma.com/design/yg7J0qZnn7wX9fLBBYgVdy/Responsive---Design-System?node-id=5339-6143&m=dev
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SearchField = function SearchField(_ref) {
  var onChange = _ref.onChange,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "Search" : _ref$placeholder,
    _ref$leadingIcon = _ref.leadingIcon,
    leadingIcon = _ref$leadingIcon === void 0 ? "fa-light fa-magnifying-glass" : _ref$leadingIcon,
    _ref$enableClear = _ref.enableClear,
    enableClear = _ref$enableClear === void 0 ? false : _ref$enableClear,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value;
  var clearInput = function clearInput() {
    onChange({
      target: {
        value: ""
      }
    });
  };
  return /*#__PURE__*/_jsxs("span", {
    style: {
      "--border-color": RaiseColors.neutral300,
      "--background-color": RaiseColors.neutral100,
      "--hover-border-color": RaiseColors.neutral500,
      "--active-border-color": RaiseColors.teal,
      "--active-box-shadow-color": "rgba(0, 166, 202, 0.08)"
    },
    className: styles.searchFieldContainer,
    children: [leadingIcon ? /*#__PURE__*/_jsx("span", {
      className: leadingIcon
    }) : null, /*#__PURE__*/_jsx("input", {
      type: "text",
      value: value || "",
      className: styles.searchField,
      placeholder: placeholder,
      onChange: onChange
    }), enableClear && (value === null || value === void 0 ? void 0 : value.length) > 0 && /*#__PURE__*/_jsx("span", {
      className: classnames(styles.xStyles, IconConstants.X),
      onClick: clearInput
    })]
  });
};
export default SearchField;